export const CalendarType = Object.freeze({
  RANGE: 'range',
})

export const ActiveDatePicker = Object.freeze({
  START: 'start',
  END: 'end',
})

/**
 * Date filter conditions for the date picker component.
 * Determines how date filtering is applied when searching bookings.
 */
export const Conditions = Object.freeze({
  /**
   * Filter for an exact date match.
   * Only a single date (startDate) is required.
   */
  IS: 'is',

  /**
   * Filter for dates occurring before the specified date.
   * Only endDate is set; startDate is left empty.
   */
  BEFORE: 'is before',

  /**
   * Filter for dates occurring after the specified date.
   * Only startDate is set; endDate is left empty.
   */
  AFTER: 'is after',

  /**
   * Filter for dates within a range (inclusive).
   * Both startDate and endDate are required.
   */
  BETWEEN: 'is between',
})

export const CalendarView = Object.freeze({
  CALENDAR: 'calendar',
  MONTH: 'month',
  YEAR: 'year',
  DAY: 'day',
})

export const Days = Object.freeze({
  SUNDAY: 'Su',
  MONDAY: 'Mo',
  TUESDAY: 'Tu',
  WEDNESDAY: 'We',
  THURSDAY: 'Th',
  FRIDAY: 'Fr',
  SATURDAY: 'Sa',
})

export const Months = Object.freeze({
  JANUARY: 'January',
  FEBRUARY: 'February',
  MARCH: 'March',
  APRIL: 'April',
  MAY: 'May',
  JUNE: 'June',
  JULY: 'July',
  AUGUST: 'August',
  SEPTEMBER: 'September',
  OCTOBER: 'October',
  NOVEMBER: 'November',
  DECEMBER: 'December',
})
